import { InstalledSoftware } from "@/model/data/InstalledSoftware";
import { TagValues } from "@/model/data/Tag";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { IsNamedSoftwareVersion, NamedSoftwareVersion } from "@/model/data/updates/NamedSoftwareVersion";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { FetchInstallationsSmartLockStatusResData } from "./FetchInstallationsSmartLockStatusResData";

const ENDPOINT = "/otc/smartlock/status";

export class FetchInstallationsSmartLockStatusCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchInstallationsSmartLockStatusReqData;

    constructor(payload: FetchInstallationsSmartLockStatusReqData) {
        super();
        this.payload = GetFetchInstallationsRemoteLinkStatusReqData(payload);
    }

    public async execute(): Promise<FetchInstallationsSmartLockStatusResData> {
        let res = await this.executeCommand(this.payload);
        return new FetchInstallationsSmartLockStatusResData(res);
    }
}

export class FetchInstallationsSmartLockStatusReqData implements IFilterInstallations, IPaginationFilter {
    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = [];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    installationLastMessageDateRange: string[] = [];
    agentLastMessageDateRange: string[] = [];
    machineModels: string[] = null;
    tagValues: TagValues = null;
    softwareVersionFilterList: InstalledSoftware[] = [];
}

export function GetFetchInstallationsRemoteLinkStatusReqData(req: FetchInstallationsSmartLockStatusReqData): FetchInstallationsSmartLockStatusReqData {
    let softwareVersionFilterList: InstalledSoftware[] = [];
    let reqProps = Object.keys(req);

    reqProps.forEach((prop) => {
        if (Array.isArray(req[prop]) && IsNamedSoftwareVersion(req[prop][0])) {
            req[prop].forEach((softwareFilter: NamedSoftwareVersion) => {
                let sw = new InstalledSoftware();

                if (Object.keys(UpdateTypeEnum).includes(softwareFilter.name)) sw.updateType = UpdateTypeEnum[softwareFilter.name];
                else sw.updateType = UpdateTypeEnum.ThirdPartySoftware;

                sw.name = softwareFilter.name;
                sw.version = softwareFilter.version;
                softwareVersionFilterList.push(sw);
            });
        }
    });

    let res: FetchInstallationsSmartLockStatusReqData = {
        installationNames: req.installationNames,
        folderIds: req.folderIds,
        branchNames: req.branchNames,
        queryLimit: req.queryLimit,
        offset: req.offset,
        orderBy: req.orderBy,
        orderByDescending: req.orderByDescending,
        installationLastMessageDateRange: req.installationLastMessageDateRange,
        agentLastMessageDateRange: req.agentLastMessageDateRange,
        machineModels: req.machineModels,
        tagValues: req.tagValues,
        softwareVersionFilterList: softwareVersionFilterList,
    };

    return res;
}
